<script setup lang="ts">
import { logoutRedirect } from "@/auth/msal";
import { authStore } from "@/auth/authStore";
</script>

<template>
  <main class="mx-auto max-w-md px-6 py-16 text-center">
    <h1 class="text-lg font-medium">No access</h1>
    <p class="mt-4 text-sm text-fg dark:text-fg-dark">
      You don't have access to operate-playground. Ask in
      <span class="mono">#trial-ops</span> to be added to the
      <span class="mono">Playgrounds.User</span> role on this app registration.
    </p>
    <p v-if="authStore.state.me" class="mt-4 text-2xs text-fg-muted">
      Signed in as <span class="mono">{{ authStore.state.me.upn }}</span>
    </p>
    <button
      type="button"
      class="mt-6 rounded border border-border px-3 py-1.5 text-sm hover:bg-surface dark:border-border-dark dark:hover:bg-surface-dark"
      @click="logoutRedirect"
    >Sign out</button>
  </main>
</template>
